import React from "react";
// import { LoadingSalad } from "./Salad";
import i18n from "~/assets/js/Helpers/i18n";
import LoadingImage from "../../../../static/images/pottsalat-ladeanimation.gif";

const FullPageLoader = () => {
    return (
        <div className="full-page-loader">
            <div className="full-page-loader__salad">
                <img
                    src={LoadingImage}
                    alt="Ladeanimation der Seite"
                    width="160"
                />
            </div>
            <span className="full-page-loader__text">
                {i18n.t("loader.pageIsLoading")}
            </span>
        </div>
    );
};

export default FullPageLoader;
